<template>
  <base-modal :modal-id="modalId">
    <template v-slot:header>
      <button
        type="button"
        class="d-sm-none btn btn-arrow"
        data-dismiss="modal"
        @click="$bvModal.hide(modalId)"
      >
        <img src="/images/svg/global/left_arrow.svg" />
      </button>
      <h4 class="modal-title mb-0 d-sm-none">{{ _T('Password') }}</h4>
      <h4 class="modal-title mb-0 d-none d-sm-block">
        {{ _T('Change Password') }}
      </h4>
    </template>
    <template v-slot:modal-body>
      <form class="default-form">
        <div class="form-group">
          <label>{{ _T('Current password') }}</label>
          <input
            type="password"
            class="form-control"
            v-model="confirm_password"
          />
        </div>
        <div class="form-group">
          <label>{{ _T('New password') }}</label>
          <input type="password" class="form-control" v-model="password" />
        </div>
        <div class="form-group">
          <label>{{ _T('Reenter new password') }}</label>
          <input
            type="password"
            class="form-control"
            v-model="repeat_new_password"
          />
        </div>
        <div class="btns">
          <button
            type="button"
            class="btn btn-outline"
            data-dismiss="modal"
            @click="closeModal()"
          >
            {{ _T('Cancel') }}
          </button>
          <progress-bar v-if="processInProgress(process)">
            {{ _T('Saving') }}
          </progress-bar>
          <button
            v-else
            type="button"
            class="btn btn-danger"
            data-dismiss="modal"
            @click.prevent="edit_user_password"
          >
            {{ _T('Save') }}
          </button>
        </div>
      </form>
    </template>
  </base-modal>
</template>

<script>
import BaseModal from '../BaseModal'
import { mapGetters } from 'vuex'
import ProgressBar from '@/components/Elements/ProgressBar'
import { handleApiErrors } from '@/utils/main_utils.js'
export default {
  name: 'VerifyNumber',
  components: {
    BaseModal,
    ProgressBar,
  },
  computed: {
    ...mapGetters(['_T', 'processInProgress']),
  },
  methods: {
    closeModal() {
      if (this.processInProgress(this.process))
        this.$store.dispatch('stopProcess', this.process)
      this.resetModal()
      this.$bvModal.hide(this.modalId)
    },
    edit_user_password() {
      if (
        !this.edit_user_password ||
        !this.password ||
        !this.confirm_password
      ) {
        this.$store.dispatch('showNotification', {
          text: this._T('All fields required'),
          status: 'error',
        })
        return false
      } else {
        if (!this.processInProgress(this.process)) {
          this.$store.dispatch('startProcess', {
            process: this.process,
            progress: true,
          })
          this.$store
            .dispatch('edit_user_password', {
              repeat_new_password: this.repeat_new_password,
              password: this.password,
              confirm_password: this.confirm_password,
            })
            .then(resp => {
              let responseData = resp.data
              if (responseData.status === 'form_errors') {
                let errors = handleApiErrors(responseData.form_errors)
                this.$store.dispatch('showNotification', {
                  text: this._T(errors),
                  status: 'error',
                })
              } else {
                this.$store.dispatch('showNotification', {
                  text: this._T('Record updated successfully'),
                  status: 'success',
                })
                this.resetModal()
                this.$bvModal.hide(this.modalId)
              }
            })
            .catch(err => {
              this.$store.dispatch('showNotification', {
                text: this._T('Your request was not successfull'),
                status: 'error',
              })
            })
            .finally(() => {
              this.$store.dispatch('stopProcess', this.process)
            })
        }
      }
    },
    resetModal() {
      this.confirm_password = ''
      this.password = ''
      this.repeat_new_password = ''
    },
  },
  data() {
    return {
      confirm_password: '',
      password: '',
      repeat_new_password: '',
      process: 'change-password',
      modalId: 'change-password',
    }
  },
}
</script>

<style lang="scss" scoped>
  .body-rtl {
    .edit-profile {
      .modal-body {
        .btns {
          text-align: left;
          .btn {
            + .btn {
              margin-right: $px8;
              margin-left: unset;
            }
          }
        }

        label {
          text-align: right;
          float: right;
        }
      }
    }
  }
</style>
